import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import "video.js/dist/video-js.css";
import ic_close from "../../assets/icons/ic_close.svg";
import fitness_age1 from "../../assets/images/fitness_age1.png";
import { useAuthContext } from "../../context/AuthContext";
import AuthDialog from "../auth/AuthDialog";
import CustomDialog from "../basic/Dialog";
import IconButton from "../basic/IconButton";
import { ExperienceGetactyv } from "./ExperienceGetactyv";
import { HealthyLife, StartFreeTrail } from "./LandingPage";

// Login Feedback Dialog
// export function FeedbackDialog({ showFeedBack, workout, close }) {
//   const [feedback, setFeedback] = useState("");
//   const [rating, setRating] = useState([1]);
//   return (
//     <CustomDialog show={showFeedBack} close={close}>
//       <Dialog.Panel>
//         <div className="relative w-full md:max-w-4xl flex flex-row flex-1 p-4 md:p-10 bg-gradient-to-r from-[#2A2A35] to-[#494959F2]  rounded-xl ">
//           <div
//             onClick={close}
//             className="cursor-pointer bg-[#d9d9d9] rounded-full absolute -right-2 md:-right-5 -top-2 md:-top-5 w-10 h-10 justify-center items-center flex"
//           >
//             <Icon icon="carbon:close" className="h-6 w-6" />
//           </div>
//           <div className="w-full flex flex-col">
//             <p className="font-poppins bottom-3 left-5  text-white  text-lg md:text-xl text-left  leading-snug ">
//               <span className="text-primary-neonGreen font-bold text-2xl md:text-4xl">
//                 Congratulations{" "}
//               </span>
//               <br /> on completing your first workout!
//             </p>
//             <p className="text-white font-bold md:text-lg text-left mt-5">
//               How was your overall experience?*
//             </p>

//             <div className="relative px-5">
//               <Range
//                 aria-label="Workout Duration"
//                 step={1}
//                 min={1}
//                 max={10}
//                 values={rating}
//                 onChange={(values) => {
//                   setRating(values);
//                 }}
//                 renderTrack={({ props, children }) => (
//                   <div
//                     {...props}
//                     style={{
//                       ...props.style,
//                       background: getTrackBackground({
//                         values: rating,
//                         colors: ["#0B28AC", "#6376CD"],
//                         min: 1,
//                         max: 10,
//                       }),
//                       cursor: "pointer",
//                     }}
//                     className="w-full h-2 mt-12 rounded-full "
//                   >
//                     {children}
//                   </div>
//                 )}
//                 renderThumb={({ props }) => (
//                   <div
//                     aria-label="meeting minutes thumb"
//                     {...props}
//                     style={{
//                       ...props.style,
//                       outline: "none",
//                       cursor: "pointer",
//                     }}
//                     className={`flex justify-center`}
//                   >
//                     <p
//                       className={` font-bold text-center bg-primary-midBlack  rounded-full px-4 py-2 -mt-2 text-white self-center absolute -top-8`}
//                     >
//                       {rating[0]}
//                     </p>
//                     <span
//                       aria-hidden="true"
//                       className={`
//             pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
//                     >
//                       <span
//                         aria-hidden="true"
//                         className={`
//             pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
//                       />
//                     </span>
//                   </div>
//                 )}
//               />
//             </div>

//             <p className="text-white font-bold md:text-lg text-left mt-5">
//               What did you like the most?
//             </p>
//             <textarea
//               className="px-4 py-3 mt-5 rounded-lg border-[1px] bg-transparent text-white placeholder-primary-gray border-gray-300 w-full"
//               rows={3}
//               value={feedback}
//               onChange={(e) => {
//                 setFeedback(e.target.value);
//               }}
//               placeholder="Enter your feedback here"
//             />

//             <div
//               onClick={async () => {
//                 const response = await postTrailFeedback({
//                   rating: rating[0],
//                   feedback: feedback,
//                   workout: workout,
//                 });
//                 toast("Thank you for your feedback");
//                 close();
//               }}
//               className="text-primary-black max-w-max mt-5 flex bg-primary-neonGreen p-3 rounded-xl font-open-sans cursor-pointer"
//             >
//               Submit
//             </div>
//           </div>
//         </div>
//       </Dialog.Panel>
//     </CustomDialog>
//   );
// }

// 1ST STEP
export function CardioStep1({
  //   CardioHealth,
  //   setFullName,
  //   setMobile,
  //   setDob,
  //   fullName,
  //   mobile,
  //   dob,
  onClickNext,
}) {
  const [showAuth, setShowAuth] = useState(false);
  const videoNode = useRef();
  const playerRef = useRef();

  return (
    <Transition appear show={true}>
      <Transition.Child
        as={Fragment}
        enter="transform transition ease-in-out duration-300"
        leave="transform transition ease-in-out duration-300"
      >
        <div>
          <div className="w-full h-full grid lg:grid-cols-2 grid-cols-1 font-open-sans lg:px-24 md:px-20 md:py-10 px-12 lg:py-12 py-6">
            <AuthDialog open={showAuth} setOpen={setShowAuth} />
            <video
              id="istructionVideo"
              src="https://getactyvfitness.blob.core.windows.net/old-videos/fitnessage_video.mp4"
              // ref={videoNode}
              autoPlay
              controls={false}
              playsInline
              width={540}
              loop
              muted
              preload="metadata"
              className="object-cover xl:w-[660px]"
            />

            <div
              style={{
                backgroundImage: `url(${fitness_age1})`,
                backgroundSize: "cover",
              }}
              className="grid grid-row-2 px-7 pt-10 lg:-ml-1"
            >
              <p className="lg:text-4xl md:text-2xl text-xl font-bold text-white font-poppin">
                Know Your{" "}
                <span className="text-primary-neonGreen">Cardio Health</span>
                <br />
                <p className="text-white">in under 5 minutes</p>
                <p className="lg:text-md md:text-lg text-sm text-[#757798] font-light  pt-5">
                  Perform three quick exercises to find out your fitness age
                </p>
              </p>
              <div
                className={`w-full transform py-6 text-left align-middle transition-all space-y-5 lg:px-10 xl:px-10 md:px-10 px-1`}
              >
                <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                  <p className="font-medium basis-2/12 text-white text-lg">
                    Name*
                  </p>
                  <input
                    className="px-4 py-3 md:w-80 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                    placeholder="Name"
                    // value={fullName}
                    // onChange={(e) => {
                    //   if (e.target.value == "") {
                    //     toast("Please entyer your name");
                    //   } else if (e.target.value.match(/^[A-Za-z ]+$/)) {
                    //     setFullName(
                    //       e.target.value
                    //         .replace(/[^\w\s\][^,\[\]\^]/gi, "")
                    //         .replace(/[0-9]/g, "")
                    //     );
                    //   }
                    // }}
                  />
                </div>
                <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                  <p className="font-medium basis-2/12 text-white text-lg">
                    Mobile
                  </p>
                  <input
                    className="px-4 py-3 md:w-80 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                    placeholder="Mobile"
                    // value={mobile}
                    // onChange={(e) => {
                    //   setMobile(e.target.value);
                    // }}
                    maxLength="12"
                    type="number"
                    pattern="[0-9]+"
                  />
                </div>
                <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                  <p className="font-medium basis-2/12 text-white text-lg">
                    Date of Birth*
                  </p>
                  <div className="md:w-80">
                    <DatePicker
                      //   selected={dob}
                      //   onChange={(date) => setDob(date)}
                      dateFormat="dd/MM/yyyy"
                      allowSameDay={false}
                      endDate={new Date()}
                      maxDate={new Date()}
                      placeholderText="Date of Birth"
                      popperPlacement="top-end"
                      closeOnScroll={false}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      className="flex flex-1 px-4 w-full h-100% py-3 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700"
                    />
                  </div>
                </div>
                <div className="flex justify-end">
                  <div
                    className="max-w-max mt-5 text-[#000000] cursor-pointer text-sm font-medium rounded-md bg-primary-neonGreen px-8 py-3"
                    onClick={async () => {
                      //   if (!fullName && CardioHealth) {
                      //     toast("Name is required", { type: "error" });
                      //   } else if (!validPhone(mobile) && CardioHealth) {
                      //     toast("Invalid mobile", { type: "error" });
                      //   } else if (!validPhone(mobile) && CardioHealth && mobile) {
                      //     toast("Invalid mobile", { type: "error" });
                      //   } else if (!dob || dob == null || dob == " ") {
                      //     toast("Invalid Date of Birth", { type: "error" });
                      //   } else {
                      //     onClickNext();
                      //   }
                      onClickNext();
                    }}
                  >
                    NEXT
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full h-full lg:px-24 md:px-20 md:py-10 px-12 py-6">
            <ExperienceGetactyv className="mt-0" />
          </div>

          <StartFreeTrail
            openAuth={() => {
              setShowAuth(true);
            }}
          />
          <HealthyLife
            openAuth={() => {
              setShowAuth(true);
            }}
          />
        </div>
      </Transition.Child>
    </Transition>
  );
}

// 2ND STEP : Popup Warning
export function CardioStep2({ open, close, onClickNext }) {
  console.log("RENDING STEP, warning popup 2");

  const navigate = useNavigate();

  return (
    <>
      <CustomDialog show={open} close={close}>
        <Dialog.Panel className="rounded-lg bg-[#0C101B] text-left shadow-xl transition-all md:mx-2 mx-1 md:my-6 my-4 px-10 py-6 sm:my-8 sm:w-full sm:max-w-lg">
          <div className="relative">
            <IconButton
              icon={ic_close}
              className="shadow-xl absolute -top-8 -right-12"
              onClick={() => {
                close();
              }}
            />
            <p className="font-medium text-white  text-md py-4 mx">
              In case of any existing injuries and/or medical condition, kindly
              consult with a certified doctor before starting this evaluation.
            </p>
            <div className="flex justify-center items-center">
              <button
                // className="font-poppins md:text-xl text-md font- md:px-6 md:py-3 rounded-md bg-primary-neonGreen text-[#000000]"
                className="max-w-max mt-5 text-[#000000] cursor-pointer text-sm font-medium rounded-md bg-primary-neonGreen px-8 py-3"
                onClick={() => {
                  onClickNext();
                }}
              >
                Next
              </button>
            </div>
          </div>
        </Dialog.Panel>
      </CustomDialog>
      <Transition appear show={true} className="bg-[#1A1B22]">
        <Transition.Child
          enter="transform transition ease-in-out duration-300"
          leave="transform transition ease-in-out duration-300"
        ></Transition.Child>
      </Transition>
    </>
  );
}

function CardioHealth() {
  const [step, setStep] = useState(0);
  const auth = useAuthContext();
  const [open, setOpen] = useState(true);
  const [userData, setUserData] = useState({});
  const [fullName, setFullName] = useState("");
  const [mobile, setMobile] = useState();
  const [dob, setDob] = useState("");
  const [redirectPath, setRedirectPath] = useState();

  // POST FITNESS AGE
  //   const createCardioHealth = async () => {
  //     if (fullName && mobile && dob) {
  //       window.location.href =
  //         "https://http://app.getactyvphysio.com/CardioHealth?fullname=" +
  //         fullName +
  //         "&mobile=" +
  //         mobile +
  //         "&dob=" +
  //         dob;
  //     }
  //   };

  return (
    <div id="CardioHealth" className="">
      <div className="bg-white bg-opacity-5 rounded-lg overflow-clip">
        <div className="">
          {step == 0 && (
            <CardioStep1
              //   CardioHealth={true}
              //   setFullName={setFullName}
              //   setMobile={setMobile}
              //   setDob={setDob}
              //   fullName={fullName}
              //   mobile={mobile}
              //   dob={dob}
              onClickNext={() => {
                document
                  .getElementById("CardioHealth")
                  .scrollIntoView({ behavior: "smooth" });
                setStep(1);
              }}
            />
          )}
          {step == 1 && (
            <CardioStep2
              open={open}
              close={() => {
                document
                  .getElementById("CardioHealth")
                  .scrollIntoView({ behavior: "smooth" });
                setStep(0);
              }}
              onClickNext={() => {
                document
                  .getElementById("CardioHealth")
                  .scrollIntoView({ behavior: "smooth" });
                setStep(3);
              }}
            />
          )}
          {/* {step == 2 && (
            <CardioStep3
              CardioHealth={true}
              setFullName={setFullName}
              setMobile={setMobile}
              setDob={setDob}
              fullName={fullName}
              mobile={mobile}
              dob={dob}
              onClickNext={() => {
                document
                  .getElementById("CardioHealth")
                  .scrollIntoView({ behavior: "smooth" });
                setStep(3);
              }}
            />
          )} */}
          {/* {step == 3 && createCardioHealth()} */}
        </div>
      </div>
    </div>
  );
}

export default CardioHealth;
